import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { FormProvider } from "./context/FormContext";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import BlockedUser from "./components/BlockedUser/BlockedUser";
import ProtectedRoutes from "./components/PrivateRoute/ProtectedRoutes";
import { AuthProvider } from "./context/AuthContext";
import { PATHS } from "./routes/paths";

import "./App.css";

function RootRoute(): React.ReactElement {
  const hasMsalHash =
    typeof window !== "undefined" &&
    window.location.hash &&
    window.location.hash.length > 1;

  if (hasMsalHash) {
    return <Login />;
  }

  return <Navigate to={PATHS.LOGIN} replace />;
}

function App(): React.ReactElement {
  return (
    <FormProvider>
      <div className="App">
        <Routes>
          {/* Rotas públicas */}
          <Route path={PATHS.ROOT} element={<RootRoute />} />
          <Route path={PATHS.LOGIN} element={<Login />} />

          {/* ROTA DO CALLBACK AZURE AD (PÚBLICA) */}
          <Route path={PATHS.AUTH_CALLBACK_AZURE_AD} element={<Login />} />

          <Route path={PATHS.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={PATHS.BLOCKED_USER} element={<BlockedUser />} />

          {/* Rotas protegidas */}
          <Route
            path="*"
            element={
              <AuthProvider>
                <ProtectedRoutes />
              </AuthProvider>
            }
          />
        </Routes>
      </div>
    </FormProvider>
  );
}

export default App;